import { couponOptions } from "../Screen/redux/api/dummyJson";
import Select from "react-select";

const SelectBox1 = ({
  selected,
  setSelected,
  options = couponOptions,
  placeholder,
  isDisabled = false,
  isClearable = true,
}) => {
  // console.log("selected", selected);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#1A77BC",
      minHeight: "25px",
      fontSize: "14px",
    }),
  };

  // console.log("options====>", options);
  return (
    <Select
      options={options}
      // placeholder={options == couponOptions ? "Region" : "Status"}
      placeholder={placeholder ? placeholder : "Select"}
      isSearchable
      styles={customStyles}
      value={selected}
      onChange={(val) => setSelected(val)}
      isDisabled={isDisabled}
      isClearable={isClearable}
    />
  );
};

export default SelectBox1;
